import React from "react";
import { StandardTableSortableHeader, ThemedTableHeader } from "../../../components/tables/StandardTable";
import { useCloseLoopGridData } from "../hooks/CloseLoopGridDataContext";
import styled from "styled-components";

const FixedHeader = styled(StandardTableSortableHeader)`
    width: ${({ width }) => width}%;
`;

export type CloseLoopHeaderProps = {
    children: React.ReactNode;
    className?: string;
    property?: string;
    width?: string | number;
};

const CloseLoopGridHeader = ({ children, className, property, width }: Readonly<CloseLoopHeaderProps>) => {
    const { sort, sortTable, isClearing } = useCloseLoopGridData();

    if (property == null)
        return <ThemedTableHeader className={className}>{children}</ThemedTableHeader>;

    const sortProperties = sort.split(',');
    const isHeaderSorted = sortProperties.some((prop) => prop.split("+")[0] === property);
    const headerDirection = isHeaderSorted && sortProperties.some((prop) => prop.toLowerCase().includes("+desc")) ? "desc" : null;

    const handleClick = () => sortTable(property);

    return (
        <FixedHeader
            className={className}
            active={isHeaderSorted}
            direction={headerDirection}
            onClick={isClearing ? null : handleClick}
            isSticky
            width={width}
        >
            {children}
        </FixedHeader>
    );
};

export default CloseLoopGridHeader;